<template>
	<div>
		<b-row class="no-gutters">
			<b-col md="12" lg="12" xl="5" class="MainLeft">
				<div class="main-image" :class="'stage_0'+stage" v-bind:style="{ height: mainLeftHeight + 'px' }">
					<div class="event-title">
						<h1>{{ $t('event_title')}}</h1>
						<h3>
							<small>{{info.itemTime}}</small>
							<br />
							{{$t('stage_0'+stage)}}
						</h3>
					</div>
					<MainLeft />
				</div>
			</b-col>
			<b-col md="12" lg="12" xl="7">
				<div class="Session" :class="'stage_0'+stage">
					<header class="p-0" data-aos="fade-up">
						<b-row align-h="between">
							<b-col cols="auto">
								<b-link to="/" v-on:click="setStage(null)">
									<svg width="2em" height="2em" viewBox="0 0 16 16"
										class="bi bi-arrow-left-circle-fill" fill="currentColor"
										xmlns="http://www.w3.org/2000/svg">
										<path fill-rule="evenodd"
											d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-7.646 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L6.207 7.5H11a.5.5 0 0 1 0 1H6.207l2.147 2.146z" />
									</svg>
								</b-link>
							</b-col>
							<b-col v-if="info.live" cols="auto">
								<b-button variant="primary">進入議程</b-button>
							</b-col>
						</b-row>
					</header>
					<div data-aos="fade-up">
						<h2 class="mb-3">
							<small class="time">{{info.starTime}} ~ {{info.endTime}}</small>
							<br />
							{{info.title}}
						</h2>
					</div>
					<div v-if="info.iframe" class="iframe-body-sty">
						<iframe class="iframe" :src="info.iframe" frameborder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen></iframe>
					</div>
					<div v-if="info.iframe2" class="iframe-body-sty">
						<iframe class="iframe" :src="info.iframe2" frameborder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowfullscreen></iframe>
					</div>
					<div v-if="info.pdf">
						{{ $t('briefing')}}：
						<b-link style="line-height:100%" variant="outline-dark" :href="'/pdf/'+info.pdf" target="_blank"
							download>
							<b-icon icon="file-earmark"></b-icon> {{ $t('download')}}
						</b-link>
					</div>
					<b-row>
						<b-col v-if="info.info" data-aos="fade-up">
							<div class="mb-5" style="line-height:200%">
								<hr />
								<div v-html="info.info"></div>
							</div>
						</b-col>
						<b-col sm="12" class="host">
							<ul class="list-unstyled">
								<li v-for="(speaker, index) in info.speaker" :key="index" class="testapeaker">
									<b-row align-v="center">
										<b-col sm="12" md="auto" class="image">
											<b-img v-if="speaker.img"
												:src="require('../assets/img/speaker/'+speaker.img)" class="img" fluid
												rounded="circle"></b-img>
										</b-col>
										<b-col>
											<h5>{{speaker.name}}</h5>
											<div v-html="speaker.career"></div>
										</b-col>
									</b-row>
								</li>
							</ul>
						</b-col>
					</b-row>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
	import MainLeft from "@/components/MainLeft.vue";
	import agenda_en from "@/data/agenda_en";
	import agenda_tc from "@/data/agenda_tc";
	export default {
		name: "Session",
		data() {
			return {
				stage: this.$route.params.stage,
				activities: this.$route.params.activities,
				activitiesItem: this.$route.params.activitiesItem,
				agendaList: null,
				info: {
					speaker: null,
					title: null,
					info: null,
					time: null,
					starTime: null,
					endTime: null,
					stage: null,
					pdf: null,
					iframe: null,
					iframe2: null,
					live: null,
				},
			};
		},
		created: function () {
			window.addEventListener("resize", this.handleResize);
			this.handleResize();
			this.setAgendaList();
		},
		destroyed() {
			window.removeEventListener("resize", this.handleResize);
		},
		methods: {
			// 移除目前 Stage 記錄
			setStage: function (value) {
				this.$store.commit("setStage", value);
			},
			setAgendaList: function () {
				//   if (localStorage.getItem("lang-mark") == "tc") {
				//     this.agendaList = agenda_tc;
				//   } else if (localStorage.getItem("lang-mark") == "en") {
				//     this.agendaList = agenda_en;
				//   }

				switch (localStorage.getItem("lang-mark")) {
					case "tc":
						this.agendaList = agenda_tc;
						break;
					case "en":
						this.agendaList = agenda_en;
						break;
					default:
						this.agendaList = agenda_en;
						break;
				}

				this.info.speaker = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].speaker;
				this.info.title = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].title;
				this.info.info = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].info;
				this.info.starTime = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].starTime;
				this.info.endTime = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].endTime;
				this.info.live = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].live;
				this.info.pdf = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].pdf;
				this.info.iframe = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].iframe;
				this.info.iframe2 = this.agendaList[this.stage].activities[
					this.activities
				].activitiesItem[this.activitiesItem].iframe2;
				this.info.itemTime = this.agendaList[this.stage].itemTime;
				this.info.stage = this.agendaList[this.stage].itemTitleSec;
			},
			handleResize() {
				this.mainLeftHeight = window.innerHeight - 120;
			},
		},
		updated() {
			this.setAgendaList();
		},
		components: {
			MainLeft,
		},
	};
</script>

<style lang="scss">
	.iframe-body-sty {
		height: 50vh;
		width: 100%;
		margin-bottom: 1rem;

		.iframe {
			width: 100%;
			height: 100%;
		}
	}
</style>